'use client';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@repo/ui';
import { useCallback, useEffect, useState } from 'react';
import { setGlobalErrorHandler } from '@/lib/global-error-dialog';

export function GlobalErrorDialog(): React.JSX.Element {
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  useEffect(() => {
    setGlobalErrorHandler((message: string) => {
      setErrorMsg(message);
    });
  }, []);

  const handleClose = useCallback(() => setErrorMsg(null), []);

  return (
    <AlertDialog open={errorMsg !== null} onOpenChange={(open) => !open && handleClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Server Error</AlertDialogTitle>
          <AlertDialogDescription>{errorMsg}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={handleClose}>OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
